import React, { Component } from 'react'
import DataGrid from "../../components/DataGrid";
import Pagination from "../../components/Pagination";
import FinancialBox from "../../components/boxes/FinancialBox";
import ProductViewBox from './ProductViewBox';
import SidebarView from '../../components/SidebarView';
import { checkTranslation, imageAddress, translate } from '../../utils/useful';
import Collapsible from 'react-collapsible';
import Responsive from '../../components/Responsive';
import Monitor from "../../windows/DeskViews/Monitor";
import TableViewer from '../../components/TableViewer';



export default class AddressPage extends Component {
    state = {
        // showCollapse: null,
        // active: false,
        selected: "address",

        // show: false,

        // product: [
        //     { name: 'Nouveau', title: 'AirPods Pro (2ᵉ génération)', price: '299,00', src: '/images/product/photo1.jfif' },
        //     { name: 'Nouveau', title: 'Coque en cuir avec MagSafe pour iPhone 14 Pro Max - Vert forêt', price: '299,00', src: '/images/product/photo2.jfif' },
        //     { name: 'Nouveau', title: 'Apple TV 4K Wi‑Fi + Ethernet avec 128 Go de stockage', price: '299,00', src: '/images/product/photo3.jfif' },
        //     { name: 'Nouveau', title: 'HomePod mini - Gris sidéral', price: '299,00', src: '/images/product/photo4.jfif' },
        //     { name: 'Nouveau', title: 'Lanière AirTag - Rose agrume', price: '299,00', src: '/images/product/photo5.jfif' },
        // ],
        // filter: [
        //     { name: 'Categories' },
        //     { name: 'Brand' },
        //     { name: 'Price' },
        // ],
        // option: [
        //     { name: "Discounts and offers", src: '/assets/icons/target.svg' },
        //     { name: "best sellers", src: '/assets/icons/flame.svg' },
        //     { name: "amazing", src: '/assets/icons/chart.svg' },
        // ],
        type: [
            { name: "{{lang}}No items saved for later", des: "{{lang}}" },
            { name: "{{lang}}Buy it again", des: "{{lang}}No items to Buy again" },
        ],

        accountList: [
            { key: "orders", icon: "/images/icons/ad-center.png", title: "{{lang}}Your Orders", des: "{{lang}}Track, return or buy things again" },
            { key: "voucher", icon: "/images/icons/ads-manager.png", title: "{{lang}}Voucher", des: "{{lang}}View balance, redeem or reload cards" },
            { key: "payments", icon: "/images/icons/comunities.png", title: "{{lang}}Your Payments", des: "{{lang}}View all transactions, manage payment methods and settings" },
            { key: "address", icon: "/images/icons/crisis.png", title: "{{lang}}Your Addresses", des: "{{lang}}View and modify your addresses" },
            { key: "wish", icon: "/images/icons/events.png", title: "{{lang}}Wish lists", des: "{{lang}}View, modify and share your lists or create new ones" },
        ],

        addresses: [
            { title: "Home", address: "4555 Hopyard Rd", city: "Pleasanton", zipcode: "94588", phonenumber: "+1 (345) 454-5554", name: "Hossein Mohseni", },
            { title: "Work", address: "6160 Chambersburg Rd", city: "Atlanta", zipcode: "30338", phonenumber: "+1 (345) 454-5554", name: "Hossein Mohseni", },
            { title: "Mom's House", address: "827 Lincolnway E", city: "Chicago", zipcode: "34553", phonenumber: "+1 (345) 454-5554", name: "Ellena Mohseni", },
            { title: "Office", address: "893 Smithfield Ave", city: "Pleasanton", zipcode: "83246", phonenumber: "+1 (345) 454-5554", name: "Hossein Mohseni", },
        ],

        headers: [
            { key: 'title', type: 'TextInput', information: { label: '{{lang}}Title' } },
            { key: 'address', type: 'TextInput', information: { label: '{{lang}}Address' } },
            { key: 'city', type: 'TextInput', information: { label: '{{lang}}City' } },
            { key: 'zipcode', type: 'TextInput', information: { label: '{{lang}}Zipcode' } },
            { key: 'phonenumber', type: 'TextInput', information: { label: '{{lang}}Phone number' } },
            { key: 'name', type: 'TextInput', information: { label: '{{lang}}Name' } },
        ],

    }

    // showNotifications = () => {

    // }

    openSidebar = () => {
        this.sidebarView.openSidebar()
    }
    // handleCollapse = (index) => {
    //     if (this.state.showCollapse == index) {
    //         this.setState({ active: !this.state.active })
    //     } else {
    //         this.setState({ showCollapse: index, active: true })
    //     }
    // }
    componentDidMount() {
        // console.log('type', this.state.type)
        this.setState({ currentIndex: 0, currentItem: this.state.type[0] })
    }

    render() {
        let type = this.state.type
        return (
            <div className='h-100 w-100 ' >
                <SidebarView width={this.props.width} ref={el => this.sidebarView = el} hideOverlay={false} widthCondition={{ xs: "100%", sm: "100%", md: '50%', lg: "33.3%", xl: "25%" }}>
                    <div className='h-100 scroll-no-scrollbar' style={{ backgroundColor: "#f6f6f6" }}>
                        <div className='w-100 flexcb px-3 py-3 position-sticky top-0' style={{ background: "linear-gradient(to right, rgba(70, 133, 204, .9), rgba(70, 70, 204, .9))", zIndex: "20" }}>
                            <div className='flexc'>
                                <img src={imageAddress(this.props.applet?.hub?.image, 'profile', 'small')} width="40px" className='prd-3' style={{ objectFit: 'cover', borderRadius: 100 }} />
                                <div className=''>
                                    <p className='font-size-20 white'>{translate('Address')}</p>
                                    <p className='white font-size-14' style={{ marginTop: "-5px" }}>{translate(`Hossein Mohseni`)}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </SidebarView>
                <div className='w-100 px-3 py-2 position-sticky top-0 h-100' style={{ background: "linear-gradient(to right, #184D94, #184D94)", }}>
                    {/* <div className='d-flex'>
                        <div className='flexcc'>
                            <button className='flexcc br-10 mrd-3 icon-box' style={{ width: "30px", height: "30px" }} onClick={() => this.props.changeStage("account")} >
                                <img width={20} src='/assets/icons/arrow-left-white.svg' />
                            </button>
                        </div>
                        <div className='flexcb w-100'>
                            <div className='flexc'>
                                <img src={imageAddress(this.props.applet?.hub?.image, 'profile', 'small')} width="40px" className='prd-3' style={{ objectFit: 'cover', borderRadius: 100 }} />
                                <div>
                                    <p className='font-size-20 white'>{translate('Your Orders')}</p>
                                    <p className='white font-size-14' style={{ marginTop: "-5px" }}>{translate(`Hossein Mohseni`)}</p>
                                </div>
                            </div>
                            <button className='icon-box px-3 py-2 br-5 flexc' onClick={() => this.openSidebar()}>
                                <img className='mrd-2' width={20} src='/assets/icons/plus-white.svg' />
                                <p className='white font-size-14'>{translate('Products')}</p>
                            </button>
                        </div>
                    </div> */}
                    <div>
                        <div className=''>
                            <div className='d-flex sc-2' style={{ overflowX: "scroll" }}>
                                {this.state.accountList.map((prop, index) => {
                                    return (
                                        <div style={{ cursor: 'pointer', }} onClick={() => { this.setState({ selected: prop.key }); this.props.changeStage(prop.key); }} className={this.state.selected == index ? " flexc selected-item-product px-3 mrd-2 white-bg title-color br-5 py-1" : "px-3 flexc mrd-2 br-5 py-1 icon-box white"}>
                                            <img className='mrd-3' style={{ width: "24px", height: "24px" }} src={prop.icon} />
                                            <p className='font-size-14 wieght-500 ' style={{ whiteSpace: "nowrap" }}>{checkTranslation(prop.title)}</p>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='container mt-3 w-100'>
                    <TableViewer
                        isLoading={this.state.isLoadingData}
                        headers={this.state.headers}
                        data={this.state.addresses}
                        actions={this.state.actions}
                        settings={{ isSortable: false }}
                        openEditModal={this.openEditModal}
                        openRemoveModal={this.openRemoveModal}
                        updateData={this.updateData}
                        ref={el => this.TableViewer = el}
                    />
                </div>
            </div>
        )
    }
}
